import styled, { css } from 'styled-components';
import { Icon } from 'src/components';
import { rtlFlip } from 'src/utils/theme';

export const Wrapper = styled.ul(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    align-self: center;
    padding: 0;
    ${theme.typography.heading.desktop.xxs}
  `,
);

export const Item = styled.li<{
  $selected?: boolean;
  $disabled?: boolean;
}>(
  ({ theme, $selected, $disabled }) => css`
    padding: 0 ${theme.sz.s2};
    height: ${theme.sz.s8};
    min-width: ${theme.sz.s8};
    text-align: center;
    margin: auto ${theme.sz.s05};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.bo.round};
    width: auto;

    > a {
      display: flex;
      color: inherit;
      text-decoration: inherit;
    }

    &:hover {
      color: ${theme.co.secondary70};
      cursor: pointer;
    }

    @media (max-width: ${theme.sz.s}) {
      margin: 0;
    }

    ${
      $selected &&
      css`
        background-color: ${theme.co.primary20};
        &:hover {
          color: ${theme.co.secondary0};
        }
      `
    }

    ${
      $disabled &&
      css`
        color: ${theme.co.secondary70};
        pointer-events: none;
      `
    }
  `,
);

export const Dots = styled.li(
  () => css`
    padding: 0;
    list-style-type: none;

    &:hover {
      background-color: transparent;
      cursor: default;
    }
  `,
);

export const ArrowItem = styled(Item)(
  ({ theme }) => css`
    margin: 0;
    min-width: auto;
    /* Hides the overflow after rotation of the icon */
    overflow: hidden;
    transform: scale(${rtlFlip(theme)});

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    @media (max-width: ${theme.sz.s}) {
      padding: 0;
    }
  `,
);

export const ArrowIcon = styled(Icon)<{ $next?: true; $prev?: true }>(
  ({ $next, $prev, theme }) => css`
    font-size: ${theme.sz.s5};

    ${
      $next &&
      css`
        transform: rotate(270deg);
      `
    }

    ${
      $prev &&
      css`
        transform: rotate(90deg);
      `
    }

    &:hover {
      background-color: transparent;
    }
  `,
);
